export default __webpack_public_path__ + "static/media/default-company-image.e76eb7ed.png";